<template>
    <div class="help-center-content">
        <h4>试音技巧</h4>
        <p class="title">1.  什么样的试音音频更容易中选呢？</p>
        <p class="content">①有专业的录音设备，音频无电流，无杂音，无混响之类，声音不能忽大忽小；<br>
            ②普通话标准，咬字清晰，口齿清楚，断字断句符合规范；<br>
            ③播读有感情，忌朗读课文，试音选段挑选得比较好（有旁白有对话有情节冲突的内容）；<br>
            ④一定要选择适合自己声线的作品；<br>
            ⑤可适当添加后期处理；<br>
            ⑥双人/多人是加分项；<br>
            ⑦闲的时候可以多试几本，增加被选中的概率；<br>
            以上我都达到了，为什么还是没被选中呢？<br>
            这个时候亲就要考虑平时是否经常断更，经常没有按照录制要求录制，经常试音被选中了无故拒绝邀约，录制的作品不符合要求，毫无理由地骚扰编辑，干扰编辑的正常工作等等。
        </p>
        <p class="title">2.  如何录制一个好音频？</p>
        <p class="content">“工欲善其事，必先利其器”。在开始前，您可能需要了解下录音设备，请参考<router-link :to="{name: 'pickEquipment'}">录音设备挑选</router-link>。<br>
            除了设备外，掌握<router-link :to="{name: 'announceTips'}">有声播讲技巧</router-link>和<router-link :to="{name: 'audioPostProgress'}">音频后期方法</router-link>，也能够帮你录制出优质音频，提高海选中选几率。
        </p>
        <p class="title">3.  请问手机是否可以参与有声化平台的试音？</p>
        <p class="content">您好，实在抱歉，因为目前没有任何手机能够录制的出192Kbps音质的声音，即使编辑给您通过了，也是很难得到听众的认可的，希望您能够理解。</p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {

    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>


// WEBPACK FOOTER //
// AuditionTips.vue?7428f45d